import React from 'react';
import { ChevronRight } from 'lucide-react';
export const Hero = () => {
  return <section className="relative w-full pt-40 pb-28 md:pt-48 md:pb-32 overflow-hidden" data-id="element-186">
      {/* Abstract Background Elements */}
      <div className="absolute top-20 right-0 w-[600px] h-[600px] gradient-circle opacity-30" data-id="element-187"></div>
      <div className="absolute bottom-0 left-10 w-[500px] h-[500px] gradient-circle opacity-20" data-id="element-188"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-189">
        <div className="flex flex-col lg:flex-row items-center" data-id="element-190">
          <div className="lg:w-1/2 lg:pr-12 mb-10 lg:mb-0 reveal" data-id="element-191">
            <div className="inline-block bg-glass px-4 py-1 rounded-full text-xs font-medium mb-6 text-[#30c5e8]" data-id="element-192">
              THE FUTURE OF REAL ESTATE
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-193">
              MUNISVerse{' '}
              <span className="text-gradient glow-text font-extrabold" data-id="element-194">
                Unlocking New Immersive Spaces
              </span>
            </h1>
            <p className="text-lg text-gray-300 mb-8 max-w-xl" data-id="element-195">
              Experience real estate like never before with our revolutionary VR
              technology. Explore properties from anywhere in the world with
              stunning detail and immersion.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-196">
              <a href="#contact" className="btn-gradient text-white px-8 py-3 rounded-md transition-all duration-300 text-center sm:text-left font-medium" data-id="element-197">
                Book a Demo
              </a>
              <a href="#how-it-works" className="flex items-center justify-center sm:justify-start text-[#30c5e8] font-medium hover:text-white transition-colors group" data-id="element-198">
                We Build Buyer Confidence{' '}
                <ChevronRight size={18} className="ml-1 transition-transform duration-300 group-hover:translate-x-1" data-id="element-199" />
              </a>
            </div>
          </div>
          <div className="lg:w-1/2 relative reveal" data-id="element-200">
            <div className="relative z-10 rounded-xl overflow-hidden bg-glass neon-border animate-float flex items-center justify-center" data-id="element-201">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kckmD2LyckZiSwo7KhXyTU/vr_lady_pinterest_-_Edited.png" alt="Woman with purple hair wearing VR headset" className="w-[30%] h-auto mix-blend-luminosity opacity-90" data-id="element-202" />
              <div className="absolute inset-0 bg-gradient-to-tr from-[rgba(23,27,49,0.4)] to-[rgba(48,197,232,0.1)]" data-id="element-203"></div>
            </div>
            {/* Floating Elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-glass rounded-lg shadow-lg z-0 animate-float-delayed" data-id="element-204"></div>
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-glass rounded-lg shadow-lg z-0 animate-float" data-id="element-205"></div>
            {/* VR Headset Graphic */}
            <div className="absolute -bottom-4 right-4 w-32 h-32 bg-glass rounded-full z-20 flex items-center justify-center p-3 neon-border" data-id="element-206">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vvS3KjqGCM41zdLEffR3fA/vr_hand.png" alt="VR headset with hand reaching" className="w-full h-full object-cover rounded-full" data-id="element-207" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};